import React, { useContext } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
// import "./style.scss";
import "./style-rtl.scss";
import { useTranslation } from "react-i18next";
import { getFeedbackSectionLabel } from "../../feedbackPageNavigation";
import { GlobalStateContext } from "../../../layouts/GlobalStates";
import { ReactComponent as Rate } from "./../../../asset/icons/rate_header.svg";
import { ReactComponent as Light } from "./../../../asset/icons/light_r.svg";
import { ReactComponent as Star } from "./../../../asset/icons/star_m.svg";
import { ReactComponent as Compare } from "./../../../asset/icons/compare-icon.svg";
import { ReactComponent as Share } from "./../../../asset/icons/share_c.svg";
import { ReactComponent as Comment } from "./../../../asset/icons/comment-icon.svg";
import { ReactComponent as Forum } from "./../../../asset/icons/forum-icon.svg";
import { ReactComponent as Details } from "./../../../asset/icons/details-icon.svg";
import { Shop, VideoPlay } from "iconsax-react";

export default function NavBar({ id, currentTab, setCurrentTab }) {
    const { feedbackAppGlobalState } = useContext(GlobalStateContext);
    const [result, setResult] = feedbackAppGlobalState;
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const location = useLocation();
    //   const { id } = useParams();
    const currentPath =
        location.pathname.split("/")[location.pathname.split("/").length - 2];
    const visibleSections = result?.ajax?.feedback_page_sections;
    const isSectionEnabled = (code) =>
        !visibleSections ||
        visibleSections.find((section) => section.code === code)?.enabled !==
            false;
    const sectionLabel = (code, fallbackKey) =>
        getFeedbackSectionLabel(visibleSections, code, t(fallbackKey));
    return (
        <div className="navbar-main">
            <ul>
                {isSectionEnabled("details") && <li>
                    <button
                        className={`tab-box ${
                            currentPath === "feedback" ? "active" : ""
                        }`}
                        onClick={() => navigate("/feedback/" + id)}
                    >
                        <div className="box menu-2">
                            <div>
                                <Details />
                            </div>
                        </div>
                        <div>
                            {sectionLabel(
                                "details",
                                "Src.Dashboard.index.Product.Detail.Label.Short"
                            )}
                        </div>
                    </button>
                    {/*<NavLink*/}
                    {/*  to={"/feedback/" + id}*/}
                    {/*  className={*/}
                    {/*    currentPath === "feedback" ? "nav-active-style" : ""*/}
                    {/*  }*/}
                    {/*  replace={true}*/}
                    {/*>*/}
                    {/*  {t("features.label")}*/}
                    {/*</NavLink>*/}
                </li>}
                {
                    // result.ajax.item?.menu_exist && (
                    // <li>
                    //   <button
                    //     className={`tab-box ${currentPath === "menu" ? "active" : ""}`}
                    //     onClick={() => navigate("/feedback/menu/" + id)}
                    //   >
                    //     <div className="box menu-13">
                    //       <div>
                    //         <Menu/>
                    //       </div>
                    //     </div>
                    //     <div>{t("menu")}</div>
                    //   </button>
                    // </li>
                    // )
                }
                {isSectionEnabled("feedback") && <li>
                    <button
                        className={`tab-box ${
                            currentPath === "form" ? "active" : ""
                        }`}
                        onClick={(e) => {
                            navigate("/feedback/form/" + id);
                        }}
                    >
                        <div className="box menu-6">
                            <div>
                                <Comment />
                            </div>
                        </div>
                        <div>
                            {sectionLabel(
                                "feedback",
                                "Src.Dashboard.index.Comment.Label"
                            )}
                        </div>
                    </button>
                    {/*<NavLink*/}
                    {/*  to={"/feedback/form/" + id}*/}
                    {/*  className={*/}
                    {/*    currentPath === "form" ? "nav-active-style" : ""*/}
                    {/*  }*/}
                    {/*  replace={true}*/}
                    {/*>*/}
                    {/*  {t("feedback.label")}*/}
                    {/*</NavLink>*/}
                </li>}
                {isSectionEnabled("suggestion") && <li>
                    <button
                        className={`tab-box ${
                            currentPath === "more" ? "active" : ""
                        }`}
                        onClick={() => navigate("/feedback/more/" + id)}
                    >
                        <div className="box menu-3">
                            <div>
                                <Light />
                            </div>
                        </div>
                        <div>
                            {sectionLabel(
                                "suggestion",
                                "Src.Dashboard.index.Idea.Label"
                            )}
                        </div>
                    </button>
                </li>}
                {isSectionEnabled("share") && <li>
                    <button
                        className={`tab-box ${
                            currentPath === "share-product" ? "active" : ""
                        }`}
                        onClick={() =>
                            navigate("/feedback/share-product/" + id)
                        }
                    >
                        <div className="box menu-8">
                            <div>
                                <Share />
                            </div>
                        </div>
                        <div>
                            {sectionLabel(
                                "share",
                                "Src.Dashboard.index.Introduce.Label.Short"
                            )}
                        </div>
                    </button>
                </li>}
                {isSectionEnabled("contents") && (
                    <li>
                        <button
                            className={`tab-box ${
                                currentPath === "contents" ? "active" : ""
                            }`}
                            onClick={() =>
                                navigate("/feedback/contents/" + id)
                            }
                        >
                            <div className="box menu-14">
                                <div>
                                    <VideoPlay size={16} variant="Bold" />
                                </div>
                            </div>
                            <div>
                                {sectionLabel("contents", "contents.tab")}
                            </div>
                        </button>
                    </li>
                )}
                {isSectionEnabled("market") &&
                    result?.ajax?.item?.menu_exist && (
                        <li>
                            <button
                                className={`tab-box ${
                                    currentPath === "menu" ? "active" : ""
                                }`}
                                onClick={() => navigate("/feedback/menu/" + id)}
                            >
                                <div className="box menu-13">
                                    <div>
                                        <Shop size={16} variant="Bold" />
                                    </div>
                                </div>
                                <div>
                                    {sectionLabel("market", "menu")}
                                </div>
                            </button>
                        </li>
                    )}
                {/* 
        <li>
          <button className={`tab-box soon`}>
            <div className="box menu-1">
              <div>
                <Rate/>
              </div>
            </div>
            <div>{t("Src.Dashboard.index.Feed.Coin.Label")}</div>
          </button>
        </li>
        <li>
          <button className={`tab-box soon`}>
            <div className="box menu-11">
              <div>
                <Compare/>
              </div>
            </div>
            <div>
              {t("Src.Dashboard.index.Compare.Label.Short")}
            </div>
          </button>
        </li>
        <li>
          <button className={`tab-box soon`}>
            <div className="box menu-12">
              <div>
                <Forum/>
              </div>
            </div>
            <div>{t("Src.Dashboard.index.Forum.Label")}</div>
          </button>
        </li>
        <li>
          <button className={`tab-box soon`}>
            <div className="box menu-5">
              <div>
                <Star/>
              </div>
            </div>
            <div>{t("Src.Dashboard.index.Best.Label")}</div>
          </button>
        </li> */}
            </ul>
        </div>
    );
}
